/**
 * Resolve organisation id for analytics API calls (matches Intervene / BF nav patterns).
 */
export function getAnalyticsOrganisationId(userInfo, selectedOrganisation = null) {
  if (selectedOrganisation) {
    return (
      selectedOrganisation?.organisation_id ??
      selectedOrganisation?.id ??
      ''
    ).toString();
  }

  const organisation = userInfo?.profile?.organisation ?? null;
  const organisationId =
    organisation?.organisation_id ??
    userInfo?.profile?.organisation_id ??
    userInfo?.organisation_id ??
    '';

  return organisationId ? String(organisationId) : '';
}
